import { SOURCE_ID, addSource, getAddBefore } from "./geoFeaturesSource";

/* EIA sedimentary basin boundaries. */
const LAYER_ID = "basins";

const SOURCE_LAYER_BASINS = "geo_features_basins";
const SOURCE_LAYER_LABELS = "geo_features_labels";

const LAYER_BASINS_ID = "Basins";
const LAYER_LABELS_ID = "Basins labels";

const TOGGLE_LAYER_IDS = [LAYER_BASINS_ID, LAYER_LABELS_ID];

const addLayers = (mapRef) => {
  const map = mapRef.current;
  const addBefore = getAddBefore(map);

  if (!map.getLayer(LAYER_BASINS_ID)) {
    map.addLayer(
      {
        id: LAYER_BASINS_ID,
        type: "line",
        source: SOURCE_ID,
        "source-layer": SOURCE_LAYER_BASINS,
        layout: {
          visibility: "none",
        },
        paint: {
          "line-color": "#01665e",
          "line-width": ["interpolate", ["linear"], ["zoom"], 4, 1.2, 10, 2.5],
          "line-dasharray": [4, 2],
        },
      },
      addBefore
    );
  }

  if (!map.getLayer(LAYER_LABELS_ID)) {
    map.addLayer(
      {
        id: LAYER_LABELS_ID,
        type: "symbol",
        source: SOURCE_ID,
        "source-layer": SOURCE_LAYER_LABELS,
        filter: ["==", ["get", "type"], "basin"],
        layout: {
          visibility: "none",
          "text-field": ["to-string", ["get", "name"]],
          "text-font": ["Prompt Regular", "Arial Unicode MS Regular"],
          "text-size": 13,
          "text-letter-spacing": 0.1,
        },
        paint: {
          "text-color": "#01665e",
          "text-halo-color": "#ffffff",
          "text-halo-width": 1.5,
        },
      },
      addBefore
    );
  }
};

const addAll = (mapRef) => {
  addSource(mapRef);
  addLayers(mapRef);
};

const setAnnotationVisibility = (action) => {
  const { mapRef, value } = action;

  if (!mapRef || !mapRef.current) return;

  const map = mapRef.current;
  const visibility = value ? "visible" : "none";

  TOGGLE_LAYER_IDS.forEach((layerId) => {
    if (map.getLayer(layerId)) {
      map.setLayoutProperty(layerId, "visibility", visibility);
    }
  });
};

export {
  SOURCE_ID,
  LAYER_ID,
  LAYER_BASINS_ID,
  LAYER_LABELS_ID,
  addAll,
  setAnnotationVisibility,
};
